export const sortByTitle = <T>(
  items: readonly T[],
  getTitle: (item: T) => string | undefined,
  locale: string
) => {
  const collator = new Intl.Collator(locale, { numeric: true, sensitivity: 'base' });
  return items
    .map((item) => ({ item, title: getTitle(item) }))
    .sort((a, b) => {
      if (!a.title || !b.title) {
        return a.title ? -1 : b.title ? 1 : 0;
      }
      return collator.compare(a.title, b.title);
    })
    .map(({ item }) => item);
};
